import React from "react";
import PropTypes from "prop-types";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";
import { format } from "date-fns";

const SubmittedDateInfo = ({ createdDate }) => {
    return (
        <VStack spacing="Zero_25">
            <Text variant="Descriptive_1_1" color="Gray_2">
                Submitted
            </Text>
            <Text variant="Body_2_2" color="Black">
                {format(new Date(createdDate), "MMM dd, yyyy")}
            </Text>
        </VStack>
    );
};

SubmittedDateInfo.propTypes = {
    createdDate: PropTypes.string.isRequired
};

export default SubmittedDateInfo;